import { getDownloadDocument } from "../containers/document/store/actions";

export const dateCurrent = (format: string, date: string = ""): string => {
  if (date === "") {
    return "";
  }

  const dateConvert = date.split("/").reverse().join("-");
  let d = new Date();

  if (Boolean(date)) {
    d = new Date(dateConvert);
  }
  let month = (d.getMonth() + 1).toString();
  let day = d.getDate().toString();
  const year = d.getFullYear();

  if (parseInt(month) <= 9) {
    month = "0" + month;
  }

  if (parseInt(day) <= 9) {
    day = "0" + day;
  }

  if (format === "en-US") {
    return year.toString() + "-" + month.toString() + "-" + day.toString();
  } else {
    // pt-BR
    return day.toString() + "/" + month.toString() + "/" + year.toString();
  }
};

export const formatDateString = (date: Date | null = null): string => {
  if (date === null) {
    return "";
  }

  if (date instanceof Date && isNaN(date.valueOf())) {
    return "";
  }

  return date.toJSON();
};

export const formatDate = (date: string): Date => {
  const newDate = date.split("-");
  const day = parseInt(newDate[0]);
  const month = parseInt(newDate[1]);
  const year = parseInt(newDate[2]);
  return new Date(`${year}-${month}-${day}`);
};

export const formatDateCurrentString = (date: string): string => {
  const newDate = date.split("-");
  const day = parseInt(newDate[0]);
  const month = parseInt(newDate[1]);
  const year = parseInt(newDate[2]);
  return `${year}-${month}-${day}`;
};

export const validStringDate = (date: string): boolean => {
  const newDate = date.split("/");
  if (newDate.length !== 3) {
    return false;
  }

  return true;
};

export const inputmaskDateBirth = (val: string) => {
  let v = val.replace(/\D/g, "").slice(0, 10);
  if (v.length >= 5) {
    return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)}`;
  } else if (v.length >= 3) {
    return `${v.slice(0, 2)}/${v.slice(2)}`;
  }
  return v;
};

export const getKeyByValue = (object: any, value: any): string => {
  let status = Object.keys(object).find((key) => object[key] === value);

  if (isNaN(parseInt(value)) && status) {
    return getKeyByValue(object, parseInt(status));
  }

  if (typeof status == "undefined") {
    status = "Não encontrado";
  }

  return status;
};

export const statusStringFilter = async (status: string | "99") => {
  switch (status) {
    case "0":
      return "pendentefornecedor";
    case "1":
      return "aprovado";
    case "2":
      return "vencido";
    case "3":
      return "reprovado";
    case "4":
      return "pendente";
    case "5":
      return "faltantes";
    default:
      return "todos";
  }
};

export const statusString = async (status: string | "99") => {
  switch (status) {
    case "0":
      return "Pendente Fornecedor";
    case "1":
      return "Aprovado";
    case "2":
      return "Vencido";
    case "3":
      return "Reprovado";
    case "4":
      return "Pendente Central";
    case "5":
      return "Faltantes";
    default:
      return "todos";
  }
};

export const downloadDocument = (path: string, documentId: number) => {
  getDownloadDocument(documentId);
};
